"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessType = void 0;
var BusinessType;
(function (BusinessType) {
    BusinessType["B2B"] = "B2B";
    BusinessType["B2C"] = "B2C";
    BusinessType["P2P"] = "P2P";
})(BusinessType || (exports.BusinessType = BusinessType = {}));
//# sourceMappingURL=business-type.js.map